var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contest-user__info"},[_c('div',{staticClass:"contest-user__name ellipsis"},[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(_vm.user.nickname))])])])}
var staticRenderFns = []

export { render, staticRenderFns }